import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import { AllVehicleTypes } from "./AllVehicleTypes";
import colorConfigs from "../../../../configs/colorConfigs";

export const VehicleTypes = () => {
  const { themeStyles } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/admin/fleet/vehicletypes/addvehicletype")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">Vehicle Type</span>
            </button>
          </div>
        </div>

        <div>
          <AllVehicleTypes />
        </div>
      </div>
    </div>
  )
}